const state = {
  terminal: 3, // 画布选择的设备
  activeComponent: {}, // 选中模板数据
  componentsData: [] // 模板组件数据
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js